{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Kerfi",
    "AVATAR": {
      "SUCCESS_DELETE": "Táknmynd bottans var eytt",
      "ERROR_DELETE": "Villa við að eyða táknmynd bottans, vinsamlegast reyndu aftur"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Uppfæra",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Vélmenni eftir löndum",
        "DESC": "Þetta pósthólf þjónar mörgum löndum. Samtal fer til vélmennis síns lands: eftir Kaufland-versluninni, markaðstorgi Allegro-pöntunarinnar eða annars eftir tungumáli kaupandans. Öll önnur samtöl fara til sjálfgefna vélmennisins hér að ofan.",
        "COUNTRY": "Veldu land",
        "BOT": "Veldu vélmenni",
        "ADD": "Bæta við vélmenni fyrir land",
        "REMOVE": "Fjarlægja",
        "DEFAULT_REQUIRED": "Veldu fyrst sjálfgefið vélmenni. Vélmenni lands kemur aðeins í stað þess fyrir það land.",
        "DISCONNECT_ALL": "Aftengja alla vélmenni"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Upplýsingar um botta",
        "URL": "Webhook-slóð"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Eyða",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Staðfesta eyðingu",
        "MESSAGE": "Ertu viss um að þú viljir eyða {name}?",
        "YES": "Já, eyða",
        "NO": "Nei, halda"
      },
      "SUBMIT": "Eyða",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Breyta",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Táknmynd botta"
      },
      "NAME": {
        "LABEL": "Nafn botta",
        "PLACEHOLDER": "Sláðu inn nafn botta"
      },
      "DESCRIPTION": {
        "LABEL": "Lýsing",
        "PLACEHOLDER": "Hvað gerir þessi botti?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook-slóð",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Nafn botta er nauðsynlegt",
        "URL": "Webhook-slóð er nauðsynleg",
        "VALID_URL": "Vinsamlegast sláðu inn gilda slóð sem byrjar á http:// eða https://"
      },
      "CANCEL": "Hætta við",
      "CREATE": "Búa til botta",
      "UPDATE": "Uppfæra botta"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
